// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TUpdateUserReplyTemplateRequest,
  TUpdateUserReplyTemplateModel,
  IMappers,
  TUpdateUserReplyTemplateResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IUpdateUserReplyTemplateResponseSchema } from '../../entities/reply_templates/UpdateUserReplyTemplateResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createUpdateUserReplyTemplateModel(
  parameters: TUpdateUserReplyTemplateRequest,
): TUpdateUserReplyTemplateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/update-user-reply-template/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IUpdateUserReplyTemplateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TUpdateUserReplyTemplateRequest;
}

export async function fetchUpdateUserReplyTemplate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUpdateUserReplyTemplateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUpdateUserReplyTemplateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUpdateUserReplyTemplateModel(parameters),
    config,
  )) as FetchResponse<TUpdateUserReplyTemplateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUpdateUserReplyTemplateResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUpdateUserReplyTemplateResponse>;
}
